export default function getFormatDate(input){
    const str=input.toString();
    const year=str.substring(0,4);
    const month=str.substring(4,6);
    const day=str.substring(6,8);
    const hour=str.substring(8,10);
    const minute=str.substring(10,12);
    const second=str.substring(12,14);

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}